import { render, staticRenderFns } from "./SearchProfile.vue?vue&type=template&id=8048861c"
import script from "./SearchProfile.vue?vue&type=script&lang=js"
export * from "./SearchProfile.vue?vue&type=script&lang=js"
import style0 from "./SearchProfile.vue?vue&type=style&index=0&id=8048861c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports